import {
  default as ClassicEditor,
  default as ClassicEditor2,
} from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";

const AddProductSuperstarFromMarketPlace = () => {
  const history = useHistory();
  const [title, setTitle] = useState("");
  const [unit_price, setUnitprice] = useState("");
  const [total_items, setItems] = useState("");
  const [keywords, setKeywords] = useState("");
  const [tax, setTax] = useState("");
  const [errorList, setErrorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUpload, setImageUpload] = useState({
    upload: {
      pictures: [],
      maxFileSize: 5242880,
      imgExtension: [".jpg", ".png"],
      defaultImages: [],
    },
  });

  const [convertedContent, setConvertedContent] = useState(null);
  const [convertedContent2, setConvertedContent2] = useState(null);

  useEffect(() => {
    setConvertedContent("");
    setConvertedContent2("");
  }, []);

  // File Handle
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl, fileKey, progress] = useFileHandleS3(file, 'marketplace/images', delKey);

  const changeHandler = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const createStarMarketplace = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", convertedContent);
    formData.append("unit_price", unit_price);
    formData.append("total_items", total_items);
    formData.append("terms_conditions", convertedContent2);
    formData.append("tax", tax);
    formData.append("keywords", keywords);
    formData.append("image", fileKey);

    axios.post(`/api/star/marketplace/store`, formData).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setTitle("");
        setUnitprice("");
        setItems("");
        setKeywords("");

        swal("Welcome", res.data.message, "success");
        history.push("/superstar/product-list/pending");
      }
      if (res.data.status === 402) {
        setErrorList(res.data.errors);
      }
    });
  };

  return (
    <div className="AS">
      <div className="mb-3 text-light d-flex border border-warning rounded-3 justify-content-center p-2 m-1">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Add Product</h4>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form onSubmit={createStarMarketplace}>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Title</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={title}
                        onChange={(event) => {
                          setTitle(event.target.value);
                        }}
                        placeholder="Enter title"
                      />
                      <span className="text-danger">{errorList.title}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Keyword</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={keywords}
                        onChange={(event) => {
                          setKeywords(event.target.value);
                        }}
                        placeholder="Enter keyword"
                      />
                      <span className="text-danger">{errorList.keywords}</span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Description</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor}
                        data={convertedContent}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Terms & Conditions</p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        editor={ClassicEditor2}
                        data={convertedContent2}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setConvertedContent2(data);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.terms_conditions}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6 label-text">
                          <p>Total Units</p>
                        </div>
                        <div className="col-md-6">
                          <input
                            placeholder="Enter units"
                            type="number"
                            className="form-control reply-control"
                            value={total_items}
                            min={0}
                            onChange={(event) => {
                              setItems(event.target.value);
                            }}
                          />
                          <span className="text-danger">
                            {errorList.total_items}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6 label-text text-md-end">
                          <p className="ms-4">Price</p>
                        </div>
                        <div className="col-md-6">
                          <input
                            placeholder="Enter price $"
                            type="number"
                            className="form-control reply-control"
                            value={unit_price}
                            min={0}
                            step=".01"
                            onChange={(event) => {
                              setUnitprice(event.target.value);
                            }}
                          />
                          <span className="text-danger">
                            {errorList.unit_price}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6 label-text text-md-start">
                          <p className="ms-4">Tax</p>
                        </div>
                        <div className="col-md-6">
                          <input
                            type="number"
                            placeholder="Enter tax"
                            className="form-control reply-control"
                            value={tax}
                            min={0}
                            onChange={(event) => {
                              setTax(event.target.value);
                            }}
                          />
                          <span className="text-danger">{errorList.tax}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Image</p>
                    </div>
                    <div className="col-md-5">
                      {fileUrl ? (
                        <img
                          src={fileUrl}
                          alt="..."
                          className="demo-preview-image img-fluid img-fluid"
                          style={{
                            height: "200px",
                            width: "300px",
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <input
                        className="form-control reply-control"
                        type="file"
                        accept="image/*"
                        onChange={(e) => changeHandler(e.target.files)}
                      />
                                              {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                      <span className="text-danger">{errorList.image}</span>
                    </div>
                  </div>

                  {/* Create Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-md-3"></div>
                    <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnCreate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnCreate fw-bold" type="submit">
                          Save
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Create Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProductSuperstarFromMarketPlace;
